import { GlobalOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher({ className }) {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLanguage);
  };

  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
    if (i18n.language === "ar") {
      document.documentElement.classList.add("rtl");
    } else {
      document.documentElement.classList.remove("rtl");
    }
  }, [i18n.language]);

  return (
    <button
      className={`flex items-center md:px-4 px-2 md:py-2 py-1 bg-indigo-300 text-white rounded shadow hover:bg-indigo-400 focus:outline-none ${className || ''}`}
      onClick={toggleLanguage}
    >
      <GlobalOutlined className={i18n.language === "en" ? "mr-2" : "ml-2"} />
      {i18n.language === "en" ? "EN-US" : "AR"}
    </button>
  );
}

export default LanguageSwitcher;
